import React, { useState, useEffect } from 'react';
import './LiveDataIndicator.css';
import massiveLogo from '../assets/massive.png';

const OptionsDataIndicator = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkRealtimeStatus();
    const interval = setInterval(checkRealtimeStatus, 60000);
    return () => clearInterval(interval);
  }, []);

  const checkRealtimeStatus = async () => {
    try {
      const response = await fetch('/api/polygon/realtime-status-options');
      const data = await response.json();
      
      if (data.status === 'success') {
        setStatus(data);
      }
      setLoading(false);
    } catch (error) {
      console.error('Ошибка проверки статуса опционов:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="live-indicator loading">
        <div className="indicator-dot pulsing"></div>
        <span className="indicator-text">Проверка...</span>
      </div>
    );
  }

  if (!status) {
    return null;
  }

  const getIndicatorClass = () => {
    if (status.market_status && !status.market_status.is_open) {
      return 'offline';
    }
    
    if (status.has_realtime) {
      return 'live';
    } else if (status.tier === 'developer') {
      return 'delayed';
    } else {
      return 'offline';
    }
  };

  const getIndicatorText = () => {
    if (status.market_status && !status.market_status.is_open) {
      const reason = status.market_status.reason;
      if (reason === 'weekend') {
        return 'Опционы: Weekend';
      } else if (reason === 'pre_market') {
        return 'Опционы: Pre-market';
      } else if (reason === 'after_hours') {
        return 'Опционы: Closed';
      }
      return 'Опционы: Market Closed';
    }
    
    if (status.has_realtime) {
      return 'Опционы: LIVE';
    } else if (status.delay_minutes > 0) {
      return `Опционы: ${status.delay_minutes} min`;
    } else {
      return 'Опционы: Offline';
    }
  };

  const getTooltipText = () => {
    if (status.market_status && !status.market_status.is_open) {
      return 'Рынок закрыт';
    }
    
    if (status.has_realtime) {
      return 'Real-time данные по опционам (Options Advanced)';
    } else if (status.delay_minutes > 0) {
      return `Задержка данных: ${status.delay_minutes} минут`;
    } else {
      return 'Данные недоступны';
    }
  };

  return (
    <div 
      className={`live-indicator ${getIndicatorClass()}`}
      title={getTooltipText()}
    >
      <div className="indicator-logo-wrapper">
        <img 
          src={massiveLogo} 
          alt="Massive" 
          className="indicator-logo"
        />
      </div>
      <span className="indicator-text">{getIndicatorText()}</span>
    </div>
  );
};

export default OptionsDataIndicator;
